import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import '@/App.css';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import KanbanBoard from '@/pages/KanbanBoard';
import UserView from '@/pages/UserView';
import ProjectView from '@/pages/ProjectView';
import CategoryView from '@/pages/CategoryView';
import Settings from '@/pages/Settings';
import CustomerPortal from '@/pages/CustomerPortal';
import CustomerIssueDetail from '@/pages/CustomerIssueDetail';
import CreateIssueWizard from '@/pages/CreateIssueWizard';
import CustomerActivityLogs from '@/pages/CustomerActivityLogs';
import CalendarDashboard from '@/pages/CalendarDashboard';
import DashboardLayout from '@/components/DashboardLayout';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [apiUrl, setApiUrl] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('mantis_token');
    const storedApiUrl = localStorage.getItem('mantis_api_url');
    if (storedToken) {
      setToken(storedToken);
      setApiUrl(storedApiUrl);
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (newToken, newApiUrl) => {
    setToken(newToken);
    setApiUrl(newApiUrl);
    setIsAuthenticated(true);
    localStorage.setItem('mantis_token', newToken);
    localStorage.setItem('mantis_api_url', newApiUrl);
  };

  const handleLogout = () => {
    setToken(null);
    setApiUrl(null);
    setIsAuthenticated(false);
    localStorage.removeItem('mantis_token');
    localStorage.removeItem('mantis_api_url');
  };

  return (
    <div className="App app-container">
      <Toaster position="top-right" toastOptions={{
        duration: 4000,
        style: {
          background: 'rgb(39, 39, 42)',
          color: 'rgb(250, 250, 250)',
          border: '1px solid rgb(63, 63, 70)',
          fontFamily: 'monospace'
        }
      }} />
      <BrowserRouter>
        <Routes>
          {/* Customer Portal - Public Routes */}
          <Route path="/customer" element={<CustomerPortal />} />
          <Route path="/customer/issue/:issueId" element={<CustomerIssueDetail />} />
          <Route path="/customer/create" element={<CreateIssueWizard />} />
          
          {/* Admin/Staff Routes */}
          <Route
            path="/login"
            element={
              !isAuthenticated ? (
                <Login onLogin={handleLogin} />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <DashboardLayout token={token} onLogout={handleLogout}>
                  <Dashboard token={token} />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/kanban"
            element={
              isAuthenticated ? (
                <DashboardLayout token={token} onLogout={handleLogout}>
                  <KanbanBoard token={token} />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/users"
            element={
              isAuthenticated ? (
                <DashboardLayout token={token} onLogout={handleLogout}>
                  <UserView token={token} />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/projects"
            element={
              isAuthenticated ? (
                <DashboardLayout token={token} onLogout={handleLogout}>
                  <ProjectView token={token} />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/categories"
            element={
              isAuthenticated ? (
                <DashboardLayout token={token} onLogout={handleLogout}>
                  <CategoryView token={token} />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/settings"
            element={
              isAuthenticated ? (
                <DashboardLayout token={token} onLogout={handleLogout}>
                  <Settings token={token} />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/activity-logs"
            element={
              isAuthenticated ? (
                <DashboardLayout token={token} onLogout={handleLogout}>
                  <CustomerActivityLogs token={token} />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/calendar-dashboard"
            element={
              isAuthenticated ? (
                <DashboardLayout token={token} onLogout={handleLogout}>
                  <CalendarDashboard token={token} />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;